import { RoleSubInfo, StatusSubInfo } from "../types/user";

export const defaultOptionRole: RoleSubInfo = { roleId: 0, role: "Select Role", };
export const defaultOptionStatus: StatusSubInfo = { statusId: 0, status: "Select Status", };

interface Statuses {
    statusId: number;
    status: string;
    isActive: boolean;
}

export const statusList: Statuses[] = [
    { statusId: 1, status: 'Active' , isActive: true},
    { statusId: 2, status: 'Inactive', isActive: false},
]

export const statusYesNoList: Statuses[] = [
    { statusId: 1, status: 'Yes' , isActive: true},
    { statusId: 2, status: 'No', isActive: false},
]